var exports = {
  "q9": "reactionToggleButton__j2dnln",
  "wn": "reactionToggleButtonReacted__8LsNyL",
  "az": "ReactionPopoverAnchor__B84pko",
  "Bp": "ReactorOverlay__Y6z4Pj",
  "p0": "ReactorList__JBsnDH",
  "fD": "Reactor__eN0k-A",
  "Pg": "ReactorIdentity__fy0rf0",
  "GB": "ReactorLogin__HNOzx4",
  "GT": "ReactorName__fWuKal",
  "p1": "MoreReactors__GgO1A-",
};

module.exports = exports;
